var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6137,
    cy: 6.67088,
    r: 4.37986,
    stroke: "#8083A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66652 17.1416C3.66534 16.8337 3.7342 16.5296 3.86789 16.2522C4.28742 15.4132 5.47049 14.9685 6.45218 14.7671C7.16017 14.616 7.87795 14.5151 8.60016 14.465C9.93727 14.3476 11.2821 14.3476 12.6192 14.465C13.3414 14.5157 14.0591 14.6166 14.7672 14.7671C15.7489 14.9685 16.932 15.3712 17.3515 16.2522C17.6203 16.8176 17.6203 17.474 17.3515 18.0394C16.932 18.9204 15.7489 19.3232 14.7672 19.5162C14.06 19.6735 13.342 19.7773 12.6192 19.8266C11.5309 19.9189 10.4375 19.9357 9.34692 19.8769C9.0952 19.8769 8.85187 19.8769 8.60016 19.8266C7.88008 19.7779 7.1648 19.6741 6.46057 19.5162C5.47049 19.3232 4.29581 18.9204 3.86789 18.0394C3.73489 17.7588 3.66609 17.4521 3.66652 17.1416Z",
    stroke: "#8083A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/User-2.4d61f912.svg";
export { ForwardRef as ReactComponent };